import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider, useCurrency } from "@/context/CurrencyContext";
import { AnalyticsInjector } from "@/components/AnalyticsInjector";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

import Home from "@/pages/Home";
import Flights from "@/pages/Flights";
import Hotels from "@/pages/Hotels";
import HotelDetail from "@/pages/HotelDetail";
import Cars from "@/pages/Cars";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyBookings from "@/pages/MyBookings";
import ManageBooking from "@/pages/ManageBooking";
import Admin from "@/pages/Admin";
import Collection from "@/pages/Collection";
import StaticPage from "@/pages/StaticPage";
import { DemoBanner } from "@/components/DemoBanner";
import { CookieConsent } from "@/components/CookieConsent";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Shell = ({ children, footer = true }) => (
  <>
    <Navbar />
    <DemoBanner />
    <main>{children}</main>
    {footer && <Footer />}
  </>
);

function AppRoutes() {
  const { code } = useCurrency();
  return (
    <Routes key={code}>
      <Route path="/" element={<Shell><Home /></Shell>} />
      <Route path="/flights" element={<Shell><Flights /></Shell>} />
      <Route path="/hotels" element={<Shell><Hotels /></Shell>} />
      <Route path="/hotels/:id" element={<Shell><HotelDetail /></Shell>} />
      <Route path="/cars" element={<Shell><Cars /></Shell>} />
      <Route path="/packages" element={<Shell><Packages /></Shell>} />
      <Route path="/packages/:id" element={<Shell><PackageDetail /></Shell>} />
      <Route path="/checkout" element={<Shell><Checkout /></Shell>} />
      <Route path="/confirmation" element={<Shell><Confirmation /></Shell>} />
      <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
      <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
      <Route path="/login" element={<Shell footer={false}><Login /></Shell>} />
      <Route path="/register" element={<Shell footer={false}><Register /></Shell>} />
      <Route path="/my-bookings" element={<Shell><MyBookings /></Shell>} />
      <Route path="/manage-booking" element={<Shell><ManageBooking /></Shell>} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/flight-hotel" element={<Shell><Collection /></Shell>} />
      <Route path="/city-breaks" element={<Shell><Collection /></Shell>} />
      <Route path="/beach-holidays" element={<Shell><Collection /></Shell>} />
      <Route path="/all-inclusive" element={<Shell><Collection /></Shell>} />
      <Route path="/family-holidays" element={<Shell><Collection /></Shell>} />
      <Route path="/last-minute" element={<Shell><Collection /></Shell>} />
      <Route path="/destinations" element={<Shell><Collection /></Shell>} />
      <Route path="/:slug" element={<Shell><StaticPage /></Shell>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CurrencyProvider>
          <AuthProvider>
            <AnalyticsInjector />
            <ScrollTop />
            <AppRoutes />
            <CookieConsent />
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </CurrencyProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
